import { render } from "./MyRedeployment.vue?vue&type=template&id=38019fbf&scoped=true"
import script from "./MyRedeployment.vue?vue&type=script&lang=js"
export * from "./MyRedeployment.vue?vue&type=script&lang=js"

import "./MyRedeployment.vue?vue&type=style&index=0&id=38019fbf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38019fbf"]])

export default __exports__